import { ICheckBoxProps } from 'typings';

import { Icon, Input, Label, Text } from './styles';

export const CheckBox = ({
  children,
  className = '',
  isPulsing = false,
  ...inputAttributes
}: ICheckBoxProps) => (
  <Label className={className}>
    <Input isPulsing={isPulsing} type="checkbox" {...inputAttributes} />
    <Text>
      <Icon />
      {children}
    </Text>
  </Label>
);
